export default __webpack_public_path__ + "static/media/playCircleIc.99afa337.svg";